<template>
	<div>
		<van-field v-if="!disabled && !readonly" :required="formCreateInject.rule.validate[0].required"
			:label="formCreateInject.prop.title.title" input-align="right">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
			<template #input>
				<van-slider :value="value" :min="min" :max="max" @input="change">
					<template #button>
						<div class="van-slider__button flex"
							style="flex-direction: column;align-items: center;justify-content: center;">
							<div style="font-weight: bold;">{{ value }}</div>
						</div>
					</template>
				</van-slider>
			</template>
		</van-field>
		<van-field v-else :required="formCreateInject.rule.validate[0].required" :value="value" readonly
			:label="formCreateInject.prop.title.title" placeholder="" @input="change" input-align="right" />
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			},
		}
	}
</script>
<style scope>

</style>
